import numbro from 'numbro'

export const roundVal = (val: number): number => {
  return Number(numbro(val).format({ mantissa: 2 }))
}
